import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';

const useDuplicateGroupIds = (amountQuestionId: string): string[] => {
  const duplicateQuestionMapping = useFlowsSelector(
    (state) => state.flows.metaData.duplicateQuestionMapping,
  );
  const duplicateQuestionIds = duplicateQuestionMapping?.[amountQuestionId];

  return duplicateQuestionIds || [];
};

export default useDuplicateGroupIds;
